import React from 'react';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './SectionTitle.module.scss';

const SectionTitle = ({ tag, value, children }) => (
  <div data-bem="SectionTitle" data-tag={fromAnyToTrimmed(tag)} className={CN.component}>
    <div className={CN.value}>{value}</div>
    <div className={CN.children}>{children}</div>
  </div>
);

export default SectionTitle;
